import { Component, OnInit, Input } from '@angular/core';
import { Unit } from '../../../models';

@Component({
    standalone: false,
    selector: 'abs-unit-details',
    template: ` {{ unit | unitName }} `
})
export class UnitDetailsComponent {
    @Input() unit: Unit;

    constructor() {}
}
